import { type SettingsItemTemplateProps } from "@/pages/settings/__components__/SettingsItemTemplate";
import { pagesPath } from "@/pathpida/generated/$path";
import { type VariousSettingsProps } from "./VariousSettings";

export const isViewList = (isView: VariousSettingsProps["isView"]): SettingsItemTemplateProps["items"] => {
  const result: SettingsItemTemplateProps["items"] = [];
  if (isView.contract === true) {
    result.push({ icon: "userAlt", text: "お支払い者情報", href: pagesPath.settings.billing.info.$url() });
  }
  result.push({ icon: "truck", text: "お届け先情報", href: pagesPath.settings.shipment.$url() });

  return result;
};
